const translations = {
  "en": {
    "Annual": "Annual",
    "Best Value": "Best Value",
    "Lifetime": "Lifetime",
    "Limited to the first %{var0} members": "Limited to the first %{var0} members",
    "Monthly": "Monthly",
    "New users can try for %{var0}": "New users can try for %{var0}",
    "New users can try for free": "New users can try for free",
    "Save %{var0}%": "Save %{var0}%",
    "Weekly": "Weekly"
  },
  "zh-tw": {
    "Annual": "年度",
    "Best Value": "最佳價值",
    "Lifetime": "終身",
    "Limited to the first %{var0} members": "僅限前 %{var0} 名會員",
    "Monthly": "每月",
    "New users can try for %{var0}": "新使用者可試用 %{var0}",
    "New users can try for free": "新使用者可免費試用",
    "Save %{var0}%": "節省 %{var0}%",
    "Weekly": "每週"
  }
};

export default translations;
